<template>
    <RentalsListingsShell>
        <HugeSpinner v-if="loadingChargeDetail && loadingTransactionDetail"/>
        <div v-else>
            <InvoiceDetailCard/>
            <SingleButtonActionbar text="Save Invoice" @click="$router.push('/error-page')" />
        </div>
    </RentalsListingsShell>
</template>

<script>
import RentalsListingsShell from '@/components/rentalsListings/shared/RentalsListingsShell.vue';
import InvoiceDetailCard from '@/components/rentalsListings/invoices/InvoiceDetailCard.vue';
import SingleButtonActionbar from '@/components/global/SingleButtonActionbar.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        RentalsListingsShell,
        InvoiceDetailCard,
        SingleButtonActionbar,
        HugeSpinner
    },
    computed: {
        ...mapState('invoices', [
            'loadingChargeDetail',
            'loadingTransactionDetail'
        ])
    },
    methods: {
        ...mapActions('invoices', ['getInvoiceDetail'])
    },
    created: function() {
        this.getInvoiceDetail(this.$route.params.id);
    }
};
</script>
